export const initialState = {
	chartsBelowCriterions: {}
};

export default { initialState };
